module.exports = __webpack_public_path__ + "static/media/Cats eyes 05_TYSKA-mixdown.931c667c.mp3";